import React from "react";
import LoginPageLinks from "newApp/utilities/LoginPageLinks";

const LoginHeader = () => {
    return (<div className="row login-header">
        <div className="row header-logo-row">
            <div className="header-logo-content">
                <div className="col-12">
                    <div className="logo-container">
                        <a title="WK Logo" href={LoginPageLinks.SoleSource}>
                            <div className="header-logo transparentLogo-header"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="breadcrumb-navigation">
            <ol>
                <li>
                    <a className="nav-link" href={LoginPageLinks.Home}>
                        <span className="nav-link-text">Home</span>
                    </a>
                    <span className="separator"/>
                </li>
                <li>
                    <a className="nav-link" href={LoginPageLinks.Solutions}>
                        <span className="nav-link-text">Solutions</span>
                    </a>
                    <span className="separator"/>
                </li>
                <li>
                    <a className="nav-link" href={LoginPageLinks.SoleSource}>
                        <span className="nav-link-text">SoleSource</span>
                    </a>
                    <span className="separator"/>
                </li>
                <li>
                    <span className="nav-link-text">Login</span>
                </li>
            </ol>
        </div>
    </div>);
};

export default LoginHeader;
